import { ICashTransactionClient } from './ICashTransactionClient';
import { CashTransactionClientMocked } from './cashTransactionClientMocked';

// Toggle between real API and mocked data
const USE_REAL_API = false;

// Factory function to get the appropriate client
export const getCashTransactionClient = (): ICashTransactionClient => {
  if (USE_REAL_API) {
    // TODO: Return real API client when backend is ready
    // return new CashTransactionClientApi();
    throw new Error('Real API not implemented yet');
  }
  return new CashTransactionClientMocked();
};

// Re-export types for convenience
export * from './cashTransactionTypes';
export type { ICashTransactionClient } from './ICashTransactionClient';
